import { z } from "zod";

const notificationDataSchema = z.object({
	notificationId: z.number(),
});

export type NotificationData = z.infer<typeof notificationDataSchema>;

export const parseNotificationData = (
	data: unknown,
): NotificationData | null => {
	const result = notificationDataSchema.safeParse(data);
	return result.success ? result.data : null;
};
